import { render, staticRenderFns } from "./Ball.vue?vue&type=template&id=54bcbae1&scoped=true&"
import script from "./Ball.vue?vue&type=script&lang=ts&"
export * from "./Ball.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54bcbae1",
  null
  
)

export default component.exports